import { render } from "./UserQueueSelect.vue?vue&type=template&id=c63070ac"
import script from "./UserQueueSelect.vue?vue&type=script&lang=js"
export * from "./UserQueueSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__